module.exports = __webpack_public_path__ + "static/media/foto1.693e55bd.png";